import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { SET_LOGGED_IN_REDIRECT, SET_CATEGORIES, SET_PRODUCTS } from '../../store/actions';
import axios from 'utils/axios';

// import { setLoggedInRedirect } from '../../store/actions';

// project imports
import useAuth from 'hooks/useAuth';
import { useEffect } from 'react';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
    const { isLoggedIn } = useAuth();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const redirect = useSelector((state) => state.account.redirect);
    const products = useSelector((state) => state?.shop?.products);
    const categories = useSelector((state) => state?.shop?.categories?.categories);
    const market_config = useSelector((state) => state.shop.config)

    useEffect(() => {
        if (!isLoggedIn) {
            if(redirect !== 'default'){
                console.log('setting redirect');
                dispatch({ type: SET_LOGGED_IN_REDIRECT, redirect: window.location.pathname });
            }
            navigate('login', { replace: true });
        }

        const get_products = async () => {
            console.log("getting products");
            try {
      
              const token = window.localStorage.getItem('token');
      
              if (token) {
                if(!products || products.length === 0) {
                  const productsResponse = await axios.get('/product');
                  const allProducts = productsResponse.data;
                  const products = allProducts.filter(prod => 
                    market_config?.id ? //check if market config is avaiable
                    prod?.organisation?.id === market_config?.id //if market config is available, filter products by market
                    : true //fallback to true and return all products if market config is not available
                  );
                  if( products.length > 0 ){
                    dispatch({ type: SET_PRODUCTS, products });
                  } else {
                    dispatch({ type: SET_PRODUCTS, allProducts });
                  }
                }
                
                if(!categories) {
                  const categoriesResponse = await axios.get('/category');
                  const allCategories = categoriesResponse.data;
                  const categories = allCategories.filter(cat => 
                    market_config?.id ? //check if market config is avaiable
                    cat?.organisation?.id === market_config?.id //if market config is available, filter categories by market
                    : true //fallback to true and return all categories if market config is not available
                  );
                  if(categories.length > 0 ){
                    dispatch({ type: SET_CATEGORIES, categories });
                  } else {
                    dispatch({ type: SET_CATEGORIES, allCategories });
                  }
                }
              }
            } catch (err) {
              console.error(err);
            }
        }
        
        get_products();

    }, [isLoggedIn, navigate]);

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
